import { useMutation } from '@tanstack/react-query';
import { updateFunctionalScore } from '../services/fuctional_checklist';

const UpdateFunctionalScore = () => {
    const updateFunctionalScoreMutation = useMutation({
        mutationFn: ({ scoreId, data }) => updateFunctionalScore(scoreId, data),
        onSuccess: (data) => {
        },
        onError: (error) => {
            console.error('Error updating functional score:', error);
        },
    });

    return updateFunctionalScoreMutation;
};

export default UpdateFunctionalScore; 